<template>
  <div class="full-height">
    <div class="pad-top-twenty margin-bottom-thirty">
      <div :class="isCarded ? 'scrollable' : ''">
        <div>
          <ion-row v-if="!isCarded">
            <ion-col class="margin-bottom-ten">
              <h3>Event Notifications</h3>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </div>
    <AgGridVue style="width: 100%; height: 100%" class="prime-grid ag-theme-alpine" rowHeight="62"
      :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="rowData" :sideBar="sideBar"
      :defaultExcelExportParams="defaultExportParams"
      @grid-ready="onGridReady" @rowClicked="onRowClicked" :modules="modules"></AgGridVue>
  </div>
</template>

<script>
import { send as httpSend } from "@/services/Api";
import { AgGridVue } from "ag-grid-vue";
import { addIcons } from "ionicons";
import { mapGetters } from "vuex";

import ModalEventNotification from "@/components/Settings/Patient/ModalEventNotification";
import { more } from "ionicons/icons";
import moment from "moment";
import { engageFhirApi } from "../../../services/EngageFhirApi";
import { getPrimeEncounter } from "./EventNotification";


addIcons({
  "md-more": more.md
});

export default {
  name: "EventsNotifications",
  components: {
    AgGridVue
  },
  props: {
    view: String,
    currentPatient: Object,
    isCarded: {
      required: false,
      type: Boolean
    }
  },
  data() {
    return {
      gridApi: null,
      defaultExportParams: {
        suppressTextAsCDATA: true,
        processCellCallback: function(params) {
          let value = params.value;
          // Prevent formula injection - security enhancement for CVE-2024-38996
          if (typeof value === 'string' && /^[=+\-@]/.test(value)) {
            value = "'" + value;
          }
          return value;
        }
      },
      columnDefs: [
        {
          headerName: "Date/Time", field: "eventDate", valueFormatter: this.timeFormatter, sortable: true, sort: "desc", editable: true, filter: "agDateColumnFilter",
          filterParams: {
            comparator: function (filterLocalDateAtMidnight, cellValue) {
              let dateAsString = moment(cellValue).utc().format("MM/DD/YYYY");
              let dateParts = dateAsString.split("/");
              let cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));

              if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
                return 0
              }

              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }

              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            }
          }
        },
        { headerName: "Admission Type", field: "admissionType", filter: true },
        { headerName: "Event", field: "eventTitle", filter: true },
        { headerName: "Patient ID", field: "patientId", filter: 'agTextColumnFilter', hide: true },
        { headerName: "Visit ID", field: "visitNumber", filter: 'agTextColumnFilter', hide: true },
        { headerName: "Location", field: "location", filter: true, valueGetter: this.fillLocationRoomPOC },
        { headerName: "Patient Class", field: "patientClass", filter: true },
        { headerName: "Attending Dr.", field: "attendingDoctor", filter: true },
        { headerName: "Admitting Dr.", field: "admittingDoctor", filter: true, hide: true },
        { headerName: "Consulting Dr.", field: "consultingDoctor", filter: true, hide: true },
        { headerName: "Dx Codes", field: "diagnosisCodes", valueGetter: this.jsonFormatter, filter: 'agTextColumnFilter', filterParams: { valueFormatter: this.jsonFormatter }, cellStyle: { 'white-space': 'pre-wrap' } },
        { headerName: "Discharge Disposition", field: "dischargeDisposition", filter: true },
        { headerName: "Sending Facility", field: "sendingFacilityName", filter: true },
        { headerName: "Source", field: "eventType", filter: 'agTextColumnFilter', hide: true }
      ],
      defaultColDef: {
        autoHeaderHeight: true,
        minWidth: 125,
        resizable: true,
        sortable: true,
        wrapHeaderText: true,
        cellClass: 'ag-grid-block-txt',
        wrapText: true,
        autoHeight: true,

      },
      sideBar: null,
      rowData: null,
      modules: [],

    };
  },
  created() {
    if (this.$route.query?.corrId && !this.primeAdtEncounterEnabled) {
      this.getDetails(this.$route.query.corrId);
    }
  },
  mounted() {
    this.getFullHistory();
  },

  computed: {
    ...mapGetters({
      canAccessAdtEncounter: "appConfig/primeAdtEncounterEnabled",
    }),
    primeAdtEncounterEnabled() {
      return this.canAccessAdtEncounter;
    },
  },
  watch: {
    canAccessAdtEncounter() {
      this.getFullHistory();
    },
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;

      this.sideBar = {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressPivotMode: true,
              suppressPivots: true,
              suppressValues: true
            }
          },
          {
            id: 'filters',
            labelDefault: 'Filters',
            labelKey: 'filters',
            iconKey: 'filter',
            toolPanel: 'agFiltersToolPanel',
          }
        ]
      };
      this.getFullHistory();
    },
    onRowClicked(params) {
      if (this.isADTsLoading == false) {
        this.getDetails(params.node.data.correlationId);
      }
    },
    jsonFormatter(d) {
      if (d != [] && d != null) {
        let returnString = "";
        let diagCode = d.data.diagnosisCodes

        for (let key in diagCode) {
          if (diagCode[key] != null) {
            if (diagCode[key].code == null || diagCode[key].code == '') {
              returnString += diagCode[key].description + "\n";
            } else if (diagCode[key].description == null || diagCode[key].description == '') {
              returnString += diagCode[key].code + "\n";
            } else if (diagCode[key].code != null && diagCode[key].description != null) {
              returnString += diagCode[key].code + ' | ' + diagCode[key].description + "\n";
            } else {
              returnString += "";
            }
          }
        }
        return returnString;
      } else {
        return d;
      }
    },
    fillLocationRoomPOC(d) {
      let locationString = "";
      let loc = d.data.location;
      let room = d.data.room;
      let poc = d.data.pointOfCare;

      const hasLoc = (loc != "" && loc != null);
      const hasRoom = (room != "" && room != null);
      const hasPoc = (poc != "" && poc != null);

      if (hasLoc) {
        locationString = "Loc: " + loc;
        if (hasRoom || hasPoc) {
          locationString += " | "
        }
      }
      if (hasRoom) {
        locationString += "Room: " + room;
        if (hasPoc) {
          locationString += " | "
        }
      }
      if (hasPoc) {
        locationString += "POC: " + poc;
      }

      return locationString;
    },
    timeFormatter(d) {
      if (this.primeAdtEncounterEnabled) {
        return moment(d.data.eventDate).format("MM/DD/YYYY - h:mmA");
      }
      return moment(d.data.eventDate)
        .utc()
        .format("MM/DD/YYYY - h:mmA");
    },
    async getCdsAdtSummary() {
      const method = "get";
      const path = document.config.patientApi + this.currentPatient.payload.beneficiary.id + "/event/full_history";
      this.isADTsLoading = true;

      httpSend({ path, method, authToken: true })
        .then(response => {
          this.isADTsLoading = false;
          if (response.status != 200) {
            throw new Error("Unreachable");
          }
          this.rowData = response.data;
        })
        .catch(error => {
          this.isADTsLoading = false;
          this.$ionic.toastController
            .create({
              header: "Error!",
              message: "There was a problem getting data.",
              duration: 4000,
              position: "top"
            })
            .then(m => m.present());
          khanSolo.log(error);
        });
    },
    getCdsAdtDetails(correlationId) {
      const method = "get";
      const path = document.config.patientApi + "event/" + correlationId;
      this.isADTsLoading = true;

      httpSend({ path, method, authToken: true })
        .then(response => {
          this.isADTsLoading = false;
          if (response.status != 200) {
            throw new Error("Unreachable");
          }
          this.openModalNotification(response.data, this.currentPatient.payload.beneficiary.id);
        })
        .catch(error => {
          this.isADTsLoading = false;
          this.$ionic.toastController
            .create({
              header: "Error!",
              message: "There was a problem getting data.",
              duration: 4000,
              position: "top"
            })
            .then(m => m.present());
          khanSolo.log(error);
        });
    },
    async getPrimeAdtSummary() {
      this.isADTsLoading = true;
      const primeAdtEncounterSummary = await this.primeAdtEncounterLoad(this.currentPatient.payload.beneficiary.id, 0);
      this.isADTsLoading = false;
      this.rowData = getPrimeEncounter(primeAdtEncounterSummary);
    },
    async gePrimeAdtDetails(correlationId) {
      const result = this.rowData?.find(item => item.correlationId == correlationId);
      this.openModalNotification(result, this.currentPatient.payload.beneficiary.id);
    },
    async getFullHistory() {
      // If `primeAdtEncounterEnabled` is true, it calls the Prime ADT summary API.
      // Otherwise, it calls the CDS ADT summary API.   
      if (this.primeAdtEncounterEnabled) {
        await this.getPrimeAdtSummary();
      } else {
        await this.getCdsAdtSummary();
      }
      if (this.$route.query?.corrId && this.primeAdtEncounterEnabled) {
        this.getDetails(this.$route.query.corrId);
      }
    },
    async getDetails(correlationId) {
      if (this.primeAdtEncounterEnabled) {
        await this.gePrimeAdtDetails(correlationId);
      } else {
        this.getCdsAdtDetails(correlationId);
      }
    },
    openModalNotification(detailsObj, beneId) {
      this.$ionic.modalController
        .create({
          component: ModalEventNotification,
          mode: "ios",
          componentProps: {
            propsData: {
              detailsObj,
              beneId,
              primeAdtEnabled: this.primeAdtEncounterEnabled
            }
          },
          backdropDismiss: false
        })
        .then(m => m.present());
    },
    saveState() {
      if (!this.gridApi) return;

      this.saveItemInState("columnState", this.gridApi.getColumnState());
      this.saveItemInState("filterModel", this.gridApi.getFilterModel());
    },
    saveItemInState(key, value) {
      window.localStorage.setItem(`${this.view}.${key}`, JSON.stringify(value));
    },
    getItemFromState(key) {
      return JSON.parse(window.localStorage.getItem(`${this.view}.${key}`));
    },
    async primeAdtEncounterLoad(beneficiary, encounterId) {
      const payload = {
        patientId: beneficiary,
        daysInterval: 30,
        encounterId: encounterId,
        eventFilters: ["A01", "A03", "A04"]
      };
      try {
        return await engageFhirApi.post(`/AdtHl7FhirBundle/search`, payload);
      } catch (error) {
        this.isADTsLoading = false;
        if ([error?.status, error?.statusCode].includes(404)) {
          khanSolo.log(`No ADT found for beneficiary ${beneficiary}`);
        } else {
          khanSolo.error(`Error fetching ADT for beneficiary ${beneficiary}`);
          khanSolo.error(error);
        }
        return [];
      }
    },
    async export() { }
  }
};
</script>

<style lang="scss">
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-alpine.css";

.ag-theme-alpine {
  --ag-row-height: 62px;
  --ag-font-family: inherit;
  --ag-border-color: rgb(242, 243, 245);
  --ag-secondary-border-color: var(--ag-border-color);
  --ag-row-border-color: var(--ag-secondary-border-color);
  --ag-header-column-resize-handle-display: block;
  --ag-header-column-resize-handle-width: 4px;
  --ag-header-column-resize-handle-color: var(--ag-border-color);

  .ag-root-wrapper {
    border-left: none;
    border-right: none;
    border-bottom: none;
  }

  .ag-root-wrapper,
  .ag-root-wrapper-body {
    height: 100%;
  }
}

.ag-grid-block-txt {
  word-break: normal;
  line-height: 20px !important;
  padding-top: 20px;
  padding-bottom: 20px;
}

.prime-grid {
  width: 100%;
  height: 100%;
}
</style>
